import ConfirmBox from "components/shared/VmwareMappingConfirmBox";
import { useState, useEffect } from "react";
import Breadcrumb from "components/shared/Breadcrumb";
import hisService from "services/admin/masters/hisService";
import Select from "react-select";
import MaterialTable from "material-table";
import { toast } from "react-toastify";
import {getMatrixId} from "utils/matriceHelpers";
import {
  MAPPING_SELECT_ERROR_TEMPLATE,
  MSG_MAPPING_DELETE_WARNING,
  MSG_MAPPING_RESTORE_WARNING,
} from "constants/admin/masters/his";
import {
  ERROR_MESSAGE_UNKNOWN,
  MSG_RECORD_CREATE,
  MSG_RECORD_DELETE,
  MSG_RECORD_UNDO_DELETE,
  MSG_RECORD_UPDATE,
} from "constants/common";

function ManageHisController() {
  const [breadcrumbs, setBreamcrumbs] = useState([
    { title: "UCP HIS Mapping Masters", url: "/admin/master/his/" },
    { title: "Manage Mapping" },
  ]);

  const serviceObj = new hisService();

  // dropdown form fields
  const [combineKeyList, setCombineKeyList] = useState([]);
  const [selectedCombineKeys, setSelectedCombineKeys] = useState(null);
  const [controllerTypeList, setControllerTypeList] = useState([]);
  const [controllerType, setControllerType] = useState(null);
  const [controllerTableData, setControllerTableData] = useState([{}]);
  const [selectedControllerDetails, setControllerDetails] = useState([]);
  const [controllerIdList, setControllerIdList] = useState([]);
  const [controllerId, setControllerId] = useState(null);
  // text form fields
  const [controllerIoCardType, setControllerIoCardType] = useState("");
  const [controllerIds, setControllerIds] = useState("");
  const [controllerFootnotes, setControllerFootnotes] = useState("");
  const [cardDriver, setCardDriver] = useState("");
  const [cardFirmware, setCardFirmware] = useState("");

  // other fields
  const [isEditForm, setEditForm] = useState(false);
  const [showDeleteConfirmBox, setDeleteConfirmBoxFunction] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [itemToBeDeleted, setItemToBeDeleted] = useState(null);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [combineKeyError, setCombineKeyError] = useState("");
  const [controllerTypeError, setControllerTypeError] = useState("");
  const [controllerError, setControllerError] = useState("");
  const [showTableLoader, setTableLoader] = useState(false);
  const [warningType, setWarningType] = useState(null);
  const Id = getMatrixId(window.location.pathname);
 
  useEffect(() => {
    getControllerData();
  }, []);

  useEffect(() => {
    // re-validate form upon field value change if form is touched
    if (isFormTouched) {
      validateControllerForm();
    }
  }, [selectedCombineKeys, selectedControllerDetails]);
  // call api to get controller mapping page data
  const getControllerData = () => {
    setTableLoader(true);
    serviceObj
      .getAllInitialData(Id)
      .then((response) => {
        let combineKeyList = response?.his_combine_keys;
        let list = combineKeyList.map((item) => {
          return {
            id: item.id,
            value: item.combine_key,
            label: item.combine_key,
          };
        });
        let controller_typeList = response?.controller_type_drop_list.map(
          (item) => {
            return {
              id: item.id,
              value: item.name,
              label: item.name,
              isDisabled: item.disabled,
            };
          }
        );

        let controller_id_list = response.controller_master_drop_list.map(
          (item) => {
            return {
              id: item.id,
              value: item.name,
              label: item.name,
              isDisabled: item.disabled,
            };
          }
        );

        let tableData = response?.his_controller_mapping_list;
        setControllerTableData(tableData);
        setCombineKeyList(list);
        setControllerTypeList(controller_typeList);
        setControllerIdList(controller_id_list);
        setTableLoader(false);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setTableLoader(false);
      });
  };
  // add controller mapping with post api call

  const addControllerMapping = (e) => {
    e.preventDefault();
    setIsFormTouched(true);
    // form fields data check validation
    const isFormValid = validateControllerForm();

    // call POST api if form is valid
    if (isFormValid) {
      //form fields data
      let payload = {
        controller_id: controllerId.id,
        controller_type: controllerType.value,
        controller_io_card_type: controllerIoCardType,
        controller_ids: controllerIds,
        controller_footnotes: controllerFootnotes,
        card_driver: cardDriver,
        card_firmware: cardFirmware,
        his_combine_keys: selectedCombineKeys.map((key) => key.id),
      };

      // api call
      serviceObj.createControllerMapping(payload).then((response) => {
        toast.success(MSG_RECORD_CREATE);
        getControllerData();
        resetForm();
      });
    }
  };
  // update controller mapping with post api call
  const updateControllerMapping = (e) => {
    e.preventDefault();
    //form fields data
    let payload = {
      controller_id: controllerId.id,
      controller_type: controllerType.value,
      controller_io_card_type: controllerIoCardType,
      controller_ids: controllerIds,
      controller_footnotes: controllerFootnotes,
      card_driver: cardDriver,
      card_firmware: cardFirmware,
      his_combine_keys: selectedCombineKeys.map((key) => key.id),
    };
    let ID = selectedControllerDetails.record_details.id;
    serviceObj
      .updateControllerMapping(ID, payload)
      .then((response) => {
        toast.success(MSG_RECORD_UPDATE);
        getControllerData();
        resetForm();
      })
      .catch((error) => toast.error(ERROR_MESSAGE_UNKNOWN));
  };
  // get edit item details from api call and store in state
  const editForm = (data) => {
    setEditForm(true);
    // call get api to get edit controller details.
    serviceObj.getControllerKeyDetails(data.id).then((response) => {
      // storing editable item details in local state for final edit api
      setControllerDetails(response);
      const selectedControllerDetails = response?.record_details;
      // combine key
      let combineKeys = response?.his_combine_keys.map((item) => {
        return {
          id: item.id,
          value: item.combine_key,
          label: item.combine_key,
          isDisabled: true,
        };
      });
      setSelectedCombineKeys(combineKeys);
      // controllerType
      let controllerTypeList = response.controller_type_drop_list;
      let controllerTypeName = response.record_details.controller_type;
      let selectedFilterTypeObj = controllerTypeList.filter(
        (item) => item.name === controllerTypeName
      )[0];

      setControllerType({
        id: selectedFilterTypeObj.id,
        value: selectedFilterTypeObj.name,
        label: selectedFilterTypeObj.name,
        isDisabled: selectedFilterTypeObj.disabled,
      });

      // controller
      setControllerId({
        id: selectedControllerDetails.controller_id,
        value: selectedControllerDetails.controller,
        label: selectedControllerDetails.controller,
        isDisabled: true,
      });

      // other text fields
      setControllerIoCardType(
        selectedControllerDetails.controller_io_card_type
      );
      setControllerIds(selectedControllerDetails.controller_ids);
      setControllerFootnotes(selectedControllerDetails.controller_footnotes);
      setCardDriver(selectedControllerDetails.card_driver);
      setCardFirmware(selectedControllerDetails.card_firmware);
    });
  };
  const cancelDeleteItem = () => {
    setDeleteConfirmBoxFunction(false);
    setItemToBeDeleted(null);
  };
  // delete or restore selected controller
  const deleteControllerFunction = () => {
    let ID = itemToBeDeleted.id;
    // delete controller Mapping is used for both delete and restore
    serviceObj
      .deleteControllerMapping(ID)
      .then((response) => {
        let toastMessage =
          warningType === "restore"
            ? MSG_RECORD_UNDO_DELETE
            : MSG_RECORD_DELETE;
        toast.success(toastMessage);
        setDeleteConfirmBoxFunction(false);
        setConfirmMessage("");
        getControllerData();
        setItemToBeDeleted(null);
      })
      .catch((error) => {
        toast.error(ERROR_MESSAGE_UNKNOWN);
        setDeleteConfirmBoxFunction(false);
        setConfirmMessage("");
        getControllerData();
        setItemToBeDeleted(null);
      });
  };

  // validate fields and set or reset error message
  const validateControllerForm = () => {
    let isFormValid = true;
    if (!selectedCombineKeys?.length) {
      setCombineKeyError(getErrorMessageFor("Combine Key"));
      isFormValid = false;
    } else {
      setCombineKeyError("");
    }
    if (!controllerType?.value) {
      setControllerTypeError(getErrorMessageFor("Controller Type"));
      isFormValid = false;
    } else {
      setControllerTypeError("");
    }

    if (!controllerId?.value) {
      setControllerError(getErrorMessageFor("Controller ID"));
      isFormValid = false;
    } else {
      setControllerError("");
    }
    return isFormValid;
  };
  // create error message based on field name
  const getErrorMessageFor = (fieldName) => {
    return MAPPING_SELECT_ERROR_TEMPLATE?.replace("_FIELD_NAME_", fieldName);
  };
  const resetForm = () => {
    setIsFormTouched(false);
    setCombineKeyError("");
    setControllerTypeError("");
    setControllerError("");
    setSelectedCombineKeys(null);
    setControllerType(null);
    setControllerDetails(null);
    setControllerId(null);
    setControllerIoCardType("");
    setControllerIds("");
    setControllerFootnotes("");
    setCardDriver("");
    setCardFirmware("");
    setEditForm(false)
  };
  // multi select dropdown function
  const selectMultipleValue = (selectedValues) => {
    setSelectedCombineKeys(selectedValues);
  };
  // show delete warning confirmation popup
  const showWarning = (rowData) => {
    let type = rowData.is_deleted ? "restore" : "delete";
    setWarningType(type);
    let message = rowData.is_deleted
      ? MSG_MAPPING_RESTORE_WARNING
      : MSG_MAPPING_DELETE_WARNING;
    setConfirmMessage(message + rowData.controller + " ?");
    setDeleteConfirmBoxFunction(true);
    setItemToBeDeleted(rowData);
  };
  return (
    <div className="form-wrap mt-3">
      <Breadcrumb data={breadcrumbs} disableEditTitle={true} />
      {showDeleteConfirmBox ? (
        <ConfirmBox
          actionHandler={deleteControllerFunction}
          handleSubmit={deleteControllerFunction}
          cancelDeleteItem={cancelDeleteItem}
        >
          {confirmMessage}
        </ConfirmBox>
      ) : null}
      {/* main form section */}
      <div className="form-group d-flex">
        <div className="col-sm-4">
          <form>
            <div className="row pl-2 pb-1">
              <div className="col-sm-11">
                <label htmlFor={""} className="mr-sm-2 mt-2">
                  <b>HIS Combine Key</b>
                </label>
                {/* add multi select dropdown */}
                <Select
                  isMulti
                  name="Combine Key"
                  options={combineKeyList}
                  classNamePrefix="select"
                  onChange={(e) => selectMultipleValue(e)}
                  value={selectedCombineKeys}
                  isSearchable={true}
                  isClearable={true}
                />
                {combineKeyError && (
                  <div className="col-sm-10 mb-2 text-danger">
                    {combineKeyError}
                  </div>
                )}

                <label htmlFor={"Controller type"} className="mr-sm-2 mt-2">
                  <b>Controller Type</b>
                </label>
                <div className="form-group">
                  <Select
                    name="Controller Type"
                    options={controllerTypeList}
                    classNamePrefix="Select"
                    onChange={(e) => setControllerType(e)}
                    value={controllerType}
                  />
                  {controllerTypeError && (
                    <div className="col-sm-10 mb-2 text-danger">
                      {controllerTypeError}
                    </div>
                  )}
                </div>
                <label htmlFor={"Controller"} className="mr-sm-2 mt-2">
                  <b>Controller</b>
                </label>
                <div className="form-group">
                  <Select
                    name="Controller"
                    options={controllerIdList}
                    classNamePrefix="Select"
                    onChange={(e) => setControllerId(e)}
                    value={controllerId}
                    isDisabled={isEditForm} 
                  />
                  {controllerError && (
                    <div className="col-sm-10 mb-2 text-danger">
                      {controllerError}
                    </div>
                  )}
                </div>
                <label
                  htmlFor={"Controller IO Card Type"}
                  className="mr-sm-2 mt-2"
                >
                  <b>Controller IO Card Type </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="Controller IO Card Type"
                    value={controllerIoCardType}
                    onChange={(e) => setControllerIoCardType(e.target.value)}
                    placeholder="Enter value"
                  />
                </div>

                <label
                  htmlFor={"Controller IO Card Type"}
                  className="mr-sm-2 mt-2"
                >
                  <b>Controller IDs (VID, DVID, SVID, SSID) </b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="vsanCapacity"
                    value={controllerIds}
                    onChange={(e) => setControllerIds(e.target.value)}
                    placeholder="Enter value"
                  />
                </div>

                <label
                  htmlFor={"Controller Footnotes"}
                  className="mr-sm-2 mt-2"
                >
                  <b>Controller Footnotes</b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="Controller Footnotes"
                    value={controllerFootnotes}
                    onChange={(e) => setControllerFootnotes(e.target.value)}
                    placeholder="Enter value"
                  />
                </div>

                <label htmlFor={"Card Driver"} className="mr-sm-2 mt-2">
                  <b>Card Driver</b>
                </label>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    maxLength="60"
                    name="Controller Footnotes"
                    value={cardDriver}
                    onChange={(e) => setCardDriver(e.target.value)}
                    placeholder="Enter value"
                  />
                </div>
              </div>
            </div>
            <label htmlFor={"Card Firmware"} className="mr-sm-2 mt-2">
              <b> Card Firmware</b>
            </label>
            <div className="form-group">
              <input
                type="text"
                className="form-control"
                maxLength="60"
                name="Card Firmware"
                value={cardFirmware}
                onChange={(e) => setCardFirmware(e.target.value)}
                placeholder="Enter value"
              />
            </div>

            <div className="col-sm-12">
              <button
                type="reset"
                onClick={resetForm}
                className="btn btn-md btn-light btn-link submit-btn-inline mr-sm-2"
              >
                <i className="fa fa-refresh"></i> Reset
              </button>
              <button
                type="submit"
                className="btn btn-md btn-dark submit-btn-inline"
                // disabled={isSubmitting}
                onClick={
                  isEditForm ? updateControllerMapping : addControllerMapping
                }
              >
                {isEditForm ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </div>
        <div className="col-sm-8">
          <MaterialTable
            title="Controller Mappings"
            columns={[
              { title: "Combine Key", field: "his_combine_key" },
              { title: "Controller Type", field: "controller_type" },
              { title: "Controller", field: "controller" },
              {
                title: "Controller IO Card Type",
                field: "controller_io_card_type",
              },
              { title: "Controller IDs", field: "controller_ids" },
              { title: "Controller Footnotes", field: "controller_footnotes" },
              { title: "Card Driver", field: "card_driver" },
              { title: "Card Firmware", field: "card_firmware" },
            ]}
            data={controllerTableData && controllerTableData}
            options={{
              headerStyle: {
                backgroundColor: "#e9ecef",
              },
              actionsColumnIndex: -1,
              selection: false,
              search: true,
              maxBodyHeight: 400,
            }}
            localization={{
              header: {
                actions: "Actions",
              },
            }}
            actions={[
              (rowData) => ({
                icon: "edit",
                tooltip: !rowData.is_deleted && "Edit Record",
                onClick: (e, data) => {
                  // call edit function
                  editForm(data);
                },
                hidden: !rowData?.id || rowData.is_deleted, // display action only if any valid item is present
              }),
              (rowData) => ({
                icon: rowData.is_deleted ? "undo" : "delete",
                tooltip: rowData.is_deleted
                  ? "Undo Deleted Record"
                  : "Delete Record",
                onClick: (e, data) => {
                  showWarning(data);
                },
                hidden: !rowData?.id, // display action only if any valid item is present
              }),
            ]}
          />
        </div>
      </div>
      {/* form end */}
    </div>
  );
}
export default ManageHisController;
